import React from 'react'
import { Link } from 'react-router-dom';
import { useDictionary } from '../../contexts/dictionary';
import { footerBg1, footerBg2, footerBg3, footerBg4, footerBg5 } from '../../constants/images';
import { useContactType } from '../../contexts/ContactContext';
import { Subscribe } from '../authentication/subscribe';
export const Footer = () => {
  const {translate} = useDictionary()
  const {contact} = useContactType()
  return (
    <div>
      
      <>
        {/* Footer Section */}
        <footer className="footer inner-footer footer-info">
          <div className="footer-top">
            <div className="container">
              <div className="row">
                <div className="col-lg-8">
                  <div className="row">
             
                    <div className="col-lg-10">
                      <div className="row">
                        
                        <div className="col-lg-4 col-md-3">
                          <div className="footer-widget footer-contact">
                            <h2 className="footer-title">{translate('site_map')}</h2>
                            <div className="footer-contact-info">
                               <div className="footer-address">
                                <p>
                                <i className="feather icon-arrow-left" /> <a href={`/`}>{translate('homepage')} </a>
                                </p>
                              </div>
                              <div className="footer-address">
                                <p>
                                <i className="feather icon-arrow-left" /> <a href={`/services`}>{translate('our_services')} </a>
                                </p>
                              </div>
                              <div className="footer-address">
                                <p>
                                <i className="feather icon-arrow-left" /> <a href={`/files/privacy.pdf`}>{translate('privacy')} </a>
                                </p>
                              </div>
                           
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-4 col-md-3">
                          <div className="footer-widget footer-contact">
                            <h2 className="footer-title">{translate('contact_us')}</h2>
                            <div className="footer-contact-info">
                              <div className="footer-address">
                                <p>
                                <i className="feather icon-map-pin" /> {translate('address')} 
                                </p>
                              </div>
                              <div className="footer-address">
                                <p>
                                <a href={`tel:${translate('phone')}`}>{translate('phone')}</a><i className="feather icon-phone-call" />
                                </p>
                              </div>
                              <div className="footer-address mb-0">
                                <p>
                                  {translate('email')}<i className="feather icon-mail" /> 
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-4 col-md-3">
                          <div className="footer-widget footer-contact">
                          <br/>
                          <br/>
                          <div className="footer-contact-info">
                         {
                          !contact && 
                          <ul className="footer-navbar-rht">
                          <li className="register-btn">
                            <Link to="/register" className="btn btn-second reg-btn">
                              <i className="feather icon-user" />
                              {translate('register')}
                            </Link>
                          </li>
                          <li className="register-btn">
                            <Link to="/login" className="btn btn-primary log-btn">
                              <i className="feather icon-lock" />
                              {translate('login')}
                            </Link>
                          </li>
                        </ul>
                         }

                          </div>
                          
                          </div>
                        </div>
                      </div>

                       <div className="social-icon">
                      <h6 className="mb-3">{translate('connect_with_us')}</h6>
                      <ul>
                        <li>
                          <a target="_blank" href="https://www.facebook.com/people/%D7%9E%D7%A9%D7%9C%D7%99%D7%9D-%D7%A4%D7%9C%D7%95%D7%A1-%D7%9C%D7%97%D7%99%D7%99%D7%9D/61576362143587/">
                            <i className="fa-brands fa-facebook" />
                          </a>
                        </li>
                        <li>
                          <a target="_blank" href="https://x.com/mashlim_plus">
                            <i className="fa-brands fa-x-twitter" />
                          </a>
                        </li>
                        
                       
                      </ul>
                    </div>
                    </div>
          
                </div>
                </div>
                <div className="col-lg-4 col-md-7">
                  <div className="footer-widget">
                    
                    {/* <div className="subscribe-input">
                      <form action="#">
                        <input
                          type="email"
                          className="form-control"
                          placeholder={translate('enter_email')}
                        />
                        <button
                          type="submit"
                          className="btn btn-md btn-primary-gradient d-inline-flex align-items-center"
                        >
                          {translate('send')}
                          <i className="isax isax-send-25 me-1" />
                          
                        </button>
                      </form>
                    </div> */}
                    <Subscribe/>
                   
                  </div>
                </div>
              </div>
            </div>
            <div className="footer-bg">
              <img
                src={footerBg1}
                alt="img"
                className="footer-bg-01"
              />
              <img
                src={footerBg2}
                alt="img"
                className="footer-bg-02"
              />
              <img
                src={footerBg3}
                alt="img"
                className="footer-bg-03"
              />
              <img
                src={footerBg4}
                alt="img"
                className="footer-bg-04"
              />
              {/* <img
                src={footerBg5}
                alt="img"
                className="footer-bg-05"
              /> */}
            </div>
          </div>
          <div className="footer-bottom">
            <div className="container">
              {/* Copyright */}
              <div className="copyright">
                <div className="copyright-text">
                  <p className="mb-0">
                    {translate('copy_right')} 
                  </p>
                </div>
        
            
              </div>
              {/* /Copyright */}
            </div>
          </div>
        </footer>
        {/* /Footer Section */}
      </>

    </div>
  )
}

export default Footer
